import React from 'react';
import {
  DataGridBody,
  DataGridRow,
  DataGrid,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridCell,
  TableColumnDefinition,
  DataGridProps,
  DataGridSelectionCellProps,
} from '@fluentui/react-components';

import { AggregationMode } from '../types';
import { useRenderingData } from '../hooks/use-rendering-props';

interface GridViewProps<T> {
  classes?: any;
  selectionMode: DataGridProps['selectionMode'],
  columns: DataGridProps['columns'],
  aggregateMode?: AggregationMode;
  infiniteScroll?: boolean;
  showSelectedOnly?: boolean;
  customFilter?: (item: T, search: string) => boolean;
  additionalDataGridProps?: DataGridProps
  additionalDataGridHeader?: any
  headersSelectionCell?: DataGridSelectionCellProps
  bodySelectionCell?: DataGridSelectionCellProps
  showEmptyGridResult?: boolean;
}

export const GridView: React.FC<GridViewProps<any>> = ({
  classes = {},
  selectionMode,
  aggregateMode,
  showSelectedOnly,
  customFilter,
  additionalDataGridHeader,
  additionalDataGridProps,
  headersSelectionCell,
  bodySelectionCell,
  showEmptyGridResult,
  columns,
}) => {
  const {
    items, onChange, dataSelection,
  } = useRenderingData({
    mode: aggregateMode,
    showSelectedOnly,
    customFilter,
  });

  const onSelectionChange: DataGridProps['onSelectionChange'] = (e, data) => {
    onChange(data.selectedItems);
  };

  if (!items.length && !showEmptyGridResult) { return null; }

  return (
    <DataGrid
      className={classes.dataGrid}
      columns={columns}
      items={items}
      selectionMode={selectionMode}
      selectedItems={dataSelection.map((item) => item.value)}
      onSelectionChange={onSelectionChange}
      getRowId={(item) => item.value}
      {...additionalDataGridProps}
    >
      {additionalDataGridHeader}
      <DataGridHeader className={classes.dataGridHeader}>
        <DataGridRow
          selectionCell={headersSelectionCell}
        >
          {({ renderHeaderCell }: TableColumnDefinition<any>) => (
            <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
          )}
        </DataGridRow>
      </DataGridHeader>
      <DataGridBody className={classes.dataGridBody}>
        {({ item, rowId }) => (
          <DataGridRow
            key={rowId}
            selectionCell={bodySelectionCell}
          >
            {({ renderCell }) => (
              <DataGridCell>{renderCell(item)}</DataGridCell>
            )}
          </DataGridRow>
        )}
      </DataGridBody>
    </DataGrid>
  );
};
